import React from 'react';
import { connect } from 'react-redux';
import { Page, Row } from 'shared/containers/portal_layout';
import IconButtonLink, { IconButton } from './IconButtonLink';
import { newReferralButtonClicked } from '../../actions/NewReferralActions';
// import PathToSuccess from 'agent_portal/components/PathToSuccess';

const StaffDashboardPage = ({ dispatch, staffEmployment }) => (
  <Page title="Dashboard">
    <p>Welcome to AristaMD!</p>
    <Row>
      <div className="span12 center" style={{ textAlign: 'center' }}>
        <ul className="quick-actions">
          <li>
            <IconButton
              path={`/a/portal/referral_profiles/new`}
              icon="survey"
              label="Create Referral"
              onClick={() => dispatch(newReferralButtonClicked())}
            />
          </li>
          <li>
            <IconButtonLink
              path={`/a/portal/referrals`}
              icon="people"
              label="My Referrals"
            />
          </li>
          <li>
            <IconButtonLink
              path={`/a/portal/patient_members`}
              icon="people"
              label="Patients"
            />
          </li>
          <li>
            <IconButtonLink
              path="/a/portal/current_agent/edit"
              icon="client"
              label="My Info"
            />
          </li>
        </ul>
      </div>
    </Row>
  </Page>
);

StaffDashboardPage.displayName = 'StaffDashboardPage';

export default connect()(StaffDashboardPage);
